<div class="d-flex align-items-center" *ngIf="data?.button">
    <div class="lh28">{{ data?.message }}</div>
    <button mat-button class="ml-auto btn-sm white" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
    </button>
</div>
<div class="text-center white" *ngIf="!data?.button">
    <div class="lh28">{{ data?.message }}</div>
</div>